import authFetch from './authFetch';
import fetch from 'isomorphic-unfetch';

export async function graphqlAuthFetch(
  resource: string,
  init: RequestInit = {},
  tryRefresh = true
): Promise<Response> {
  return await authFetch(
    resource,
    {
      mode: 'cors',
      cache: 'default',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      ...init,
    },
    tryRefresh
  );
}

export async function graphqlFetch(
  resource: string,
  init: RequestInit = {}
): Promise<Response> {
  return await fetch(resource, {
    mode: 'cors',
    cache: 'default',
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    ...init,
  });
}
